import React, { useState } from "react";
import SlidePanel from "../add_customer/SlidePanel";

const FailPanel = ({
  isFailPanelOpen,
  closeFailPanel,
  openIdentityPanel,
  openReviewPanel,
}) => {
  const [tryAgainClicked, setTryAgainClicked] = useState(false);

  const handleTryAgainButtonClick = () => {
    if (!tryAgainClicked) {
      closeFailPanel();
      openIdentityPanel();
      setTryAgainClicked(true);
    }
  };

  const handleProceedButton = () => {
    closeFailPanel();

    openReviewPanel();
  };

  return (
    <SlidePanel isOpen={isFailPanelOpen} onClose={closeFailPanel}>
      <div className="flex items-center justify-center h-full bg-white rounded-[12px]">
        <div className="text-center w-full px-6">
          <div className="mt-4 mb-12 mx-auto">
            <img src="/error_image.png" alt="Error" className="mx-auto" />

            <div className="text-[#000] text-[15px] font-normal mt-10">
              <p>
                We couldn't read the document or it might be invalid. Please try
              </p>
              <p>again.</p>
            </div>

            <div className="flex items-center justify-center mt-10 space-x-4">
              <button
                onClick={handleTryAgainButtonClick}
                type="button"
                className={`${
                  tryAgainClicked
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#074073] hover:bg-[#0086FF]"
                } text-[#FFF] font-medium rounded-[5px] text-sm px-8 py-2.5`}
                disabled={tryAgainClicked}
              >
                Try Again
              </button>

              <button
                onClick={handleProceedButton}
                type="button"
                className="text-[#074073] bg-[#FFF] border border-[#074073] hover:bg-[#F0F0F0] font-medium rounded-[5px] text-sm px-8 py-2.5"
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default FailPanel;
